import {WdiTable} from '@/components/WdiControls/WdiTable';
import React, {useState} from 'react';
import {WdiCardTitle, wdiCore, WdiModalProps} from "@/components/WdiControls";
import {Enum} from "@/enums/system";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {Button, message, Space} from 'antd';
import FormSaMktDetailAllocateCcEditApp from "@/pages/mkt/sa/MktApply/components/DetailAllocateBoEdit";
import {FormSaMkt} from "@/services/mkt/sa";
import {ResponseStatus} from "@/utils/request";
import {addAllocateAmount} from "@/pages/mkt/sa/components/data";

export type FormSaMktAllocateProps = {
  dataSource: API.FormSaMktAllocateCc[],
  onChange?: (dataSource: any) => void;
  activityStartDate?: Date;
  activityEndDate?: Date;
  readonly?: boolean;
  detailDataSource?: any[];
};

export const AllocateCcModelType = {
  Insert: 1,
  Edit: 2
}

const FormSaMktDetailAllocateCcApp: React.FC<FormSaMktAllocateProps> = (props: FormSaMktAllocateProps,) => {
  const [editModalProps, setEditModalProps] = useState<WdiModalProps>({visible: false, data: {datasource: []}});
  const {dataSource, onChange, detailDataSource} = props;
  const columns = [
    {
      title: '使用部门',
      key: 'boId',
      dataIndex: 'boId',
      width: 560,
      render: (text: any, row: any, index: any) => {
        return row.boName
      }
    },
    {
      title: '分摊比例',
      key: 'shareRate',
      dataIndex: 'shareRate',
      width: 160,
      render: (text: any, row: any, index: any) => {
        return wdiCore.Number.RateToString(text, 4)
      }
    },
    {
      title: '分摊金额',
      key: 'allocateAmount',
      dataIndex: 'amountMonth',
      width: 160,
      render: (text: any) => wdiCore.Number.AmountToString(text)
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark',
      ellipsis: true,
      //width: 600,

    }
  ];

  return (
    <>
      {editModalProps.visible &&
        <FormSaMktDetailAllocateCcEditApp
          onSave={(result) => {
            if (editModalProps.type == AllocateCcModelType.Insert) {
              const values = result?.data;
              FormSaMkt.Buttons.validateAllocateCc({
                formSaMktAllocateCcs: values,
                current: {}
              }).then(res => {
                if (res.code == ResponseStatus.SUCCESS) {
                  const newDataSource = addAllocateAmount(res.data, detailDataSource, 'shareRate');
                  setEditModalProps({visible: false})
                  onChange?.(newDataSource);
                  message.success('操作成功')
                } else {
                  message.error(res.message)
                }
              })
            }
            if (editModalProps.type == AllocateCcModelType.Edit) {
              dataSource[editModalProps.data.index] = result?.data;
              const tempResult = dataSource.slice();
              onChange?.(tempResult)
              setEditModalProps({visible: false})
              message.success('操作成功')
            }
          }}
          onClose={() => {
            setEditModalProps({visible: false})
          }}
          {...editModalProps}
        />
      }
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title={'使用部门分摊信息'}/>}
        collapsed={false}
        extra={

          <Space>
            {
              props.readonly ?
                <></> :
                <Button
                  type='primary'
                  hidden={props.readonly}
                  onClick={() => {
                    setEditModalProps({
                      visible: true,
                      type: AllocateCcModelType.Insert,
                      title: '使用部门分摊信息',
                      data: {
                        allocateCc: dataSource
                      }
                    });
                  }}
                  style={{float: 'right'}}>
                  设置使用部门分摊
                </Button>
            }
            <Button
              hidden={true}
              type='primary'>
            </Button>
          </Space>
        }
      >
        <WdiTable
          columns={columns}
          dataSource={dataSource}
          aggrColumns={[
            {
              columnName: 'shareRate',
              formatter: (result) => wdiCore.Number.RateToString(result, 4),
              digits: 4
            },
            {
              columnName: 'amountMonth',
              formatter: (result) => wdiCore.Number.AmountToString(result, 2),
              digits: 2
            }
          ]}
        />
      </WdiPanel>
    </>
  );
};

export default FormSaMktDetailAllocateCcApp;

